import { render } from "./MaestroActivosPage.vue?vue&type=template&id=0b355f17"
import script from "./MaestroActivosPage.vue?vue&type=script&lang=js"
export * from "./MaestroActivosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__